export enum StateStatus {
  Idle = 'idle',
  Loading = 'loading',
  Success = 'success',
  Error = 'Error',
}

export enum Mode {
  MakeModel = 'make_model',
  Plate = 'plate',
  VIN = 'vin',
}

export enum WidgetAppraisalMode {
  AppraisalOffer = 'appraisal_offer',
  OnlineOffer = 'online_offer',
}

export enum OfferSMS {
  None = 'none',
  All = 'all',
  Campaign = 'campaign',
  TradeIn = 'trade_in',
}
